import http from "@/utils/httpRequest";

// let baseURL="/api/workbenchlh";
// 领导项目待办时长排名
export const apiworkBenchIndexAuditListSort = (params) => {
  return http.post("/workBenchIndex/auditListSort", { ...params }, { baseURL });
};

// 领导交易统计交易量
export const apiworkBenchIndexStatisticsIndex = (params) => {
  return http.get(`/workBenchIndex/statisticsIndex?type=${params}`, {
    baseURL,
  });
};

// 领导交易统计图-交易额(万元)
export const apiworkBenchIndexIndexSummaryGraph = () => {
  return http.get(`/workBenchIndex/indexSummaryGraph`, { baseURL });
};

// 领导交易统计图-交易量
export const apiworkBenchIndexIndexlineChart = () => {
  return http.get(`workBenchIndex/indexlineChart`, { baseURL });
};

// 领导项目待办任务统计按角色统计
export const apiworkBenchIndexIndexroleStatistics = () => {
  return http.get(`/workBenchIndex/indexroleStatistics`, { baseURL });
};

// 领导项目待办任务统计按项目类型统计
export const apiprojectAuditCount = () => {
  return http.get(`/projectAuditCount`, { baseURL });
};

// 领导日历获取日程
export const apiwbschedulemanagementgetManagementBymonth = (params) => {
  return http.get(`/wbschedulemanagement/getManagementBymonth?time=${params}`, {
    baseURL,
  });
};

// 领导获取天气
export const apiworkBenchIndexweather = (params) => {
  return http.get(`/workBenchIndex/weather`, { baseURL });
};
